// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f3005977","337":"bf88ad98","667":"6d550fa1"}[chunkId] + ".chunk.js";
};